export const SET_SITE = 'SET_SITE';
